module.exports = __webpack_public_path__ + "static/media/linuxColoredIcon.54c81cfa.svg";